// Function to check screen size and set src attribute
function checkScreenAndSetSrc() {
    // Check if the screen width is larger than the mobile breakpoint
    if (window.Foundation.MediaQuery.is("medium")) {
      const videoElements = document.querySelectorAll('[data-src]');
  
      videoElements.forEach(element => {
        element.src = element.getAttribute('data-src');
        //show on load to prevent CLS
        element.addEventListener("load", () => {
          element.classList.add("loaded");
        });
      });
      
      window.removeEventListener('load', checkScreenAndSetSrc);
      window.removeEventListener('resize', checkScreenAndSetSrc);
    }
  }

  window.addEventListener('load', checkScreenAndSetSrc);
  window.addEventListener('resize', checkScreenAndSetSrc);